import { type ReactNode } from "react";

import useSubscription from "features/Subscription/useSubscription";

import { SubscriptionContext } from "./SubscriptionContext";

export const SubscriptionProvider = ({ children }: { children: ReactNode }) => {
  
  const SubscriptionContextValue = useSubscription();
  return <SubscriptionContext.Provider value={SubscriptionContextValue}>{children}</SubscriptionContext.Provider>;
};
